import saveFile from '../shell/saveFile';

export const csvCell = (value) => {
  const text = String(value ?? '');
  const safe = /^\s*[=+@-]|^[\t\r]/.test(text) ? `'${text}` : text;
  return `"${safe.replaceAll('"', '""')}"`;
};
export const exportCsv = (name, columns, rows) => {
  const content = [columns.map(csvCell).join(','), ...rows.map((r) => columns.map((key) => csvCell(r[key])).join(','))].join('\r\n');
  return saveFile(`${name}.csv`, new Blob([`\uFEFF${content}`], { type: 'text/csv;charset=utf-8;' }));
};

// Reads CSV text into rows of cells. Quoted cells may hold commas, doubled quotes and line breaks,
// as spreadsheets write them; a leading byte-order mark is ignored.
export const parseCsv = (text) => {
  const input = text.replace(/^\uFEFF/, '');
  const rows = [];
  let row = [];
  let cell = '';
  let quoted = false;
  for (let i = 0; i < input.length; i += 1) {
    const char = input[i];
    if (quoted) {
      if (char === '"' && input[i + 1] === '"') {
        cell += '"';
        i += 1;
      } else if (char === '"') {
        quoted = false;
      } else {
        cell += char;
      }
    } else if (char === '"') {
      quoted = true;
    } else if (char === ',') {
      row.push(cell);
      cell = '';
    } else if (char === '\n' || char === '\r') {
      if (char === '\r' && input[i + 1] === '\n') i += 1;
      row.push(cell);
      rows.push(row);
      row = [];
      cell = '';
    } else {
      cell += char;
    }
  }
  if (cell !== '' || row.length) {
    row.push(cell);
    rows.push(row);
  }
  return rows;
};
